var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text",style:('padding:'+_vm.schema.paddingTB+'px '+_vm.schema.paddingLR+'px;')},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.schema.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }